import { tuple } from '../../functions/tuple'

const CONTROL_HORIZONTAL_POSITIONS = tuple('left', 'center', 'right')
export type ControlHorizontalPosition = typeof CONTROL_HORIZONTAL_POSITIONS[number]
export function isHorizontalPosition(x: string | undefined): x is ControlHorizontalPosition {
  return CONTROL_HORIZONTAL_POSITIONS.includes(x as any);
}

const CONTROL_VERTICAL_POSITIONS = tuple('top', 'center', 'bottom')
export type ControlVerticalPosition = typeof CONTROL_VERTICAL_POSITIONS[number]
export function isVerticalPosition(x: string | undefined): x is ControlVerticalPosition {
  return CONTROL_VERTICAL_POSITIONS.includes(x as any);
}

export type ControlPosition = `${ControlVerticalPosition} ${ControlHorizontalPosition}`
export function getPositions(pos: string | undefined, defaultVertical: ControlVerticalPosition = 'top', defaultHorizontal: ControlHorizontalPosition = 'right'): [ControlVerticalPosition,  ControlHorizontalPosition] {
  let temp = pos?.split(' ').slice(0,2) ?? [undefined, undefined];
  return [
    isVerticalPosition(temp[0]) ? temp[0] : defaultVertical,
    isHorizontalPosition(temp[1]) ? temp[1] : defaultHorizontal,
  ]
}
export function getFlexPositions(pos: string | undefined, defaultVertical: ControlVerticalPosition = 'top', defaultHorizontal: ControlHorizontalPosition = 'right'): [string, string] {
  let [vertical, horizontal] = getPositions(pos, defaultVertical, defaultHorizontal) 
  return [
    Control2FlexVertical[vertical],
    Control2FlexHorizontal[horizontal],
  ]
}

const Control2FlexHorizontal: Record<ControlHorizontalPosition, string> = {
  'left': 'flex-start',
  'center': 'center',
  'right': 'flex-end'
};
const Control2FlexVertical: Record<ControlVerticalPosition, string> = {
  'top': 'flex-start',
  'center': 'center',
  'bottom': 'flex-end'
};
